export default "__VITE_PUBLIC_ASSET__a10ba2a7__"